import type { ApplicationConfiguration } from '@/common/overmind/namespaces/arcgis/config/config.types';

import type { Context } from '../..';

const ensureTrailingSlash = (basePath: string) =>
  `${basePath}${basePath.endsWith('/') ? '' : '/'}`;

export const setGridCalcApiUrls = (
  { effects }: Context,
  apis: ApplicationConfiguration['api']
) => {
  const orchestratorBaseUrl = ensureTrailingSlash(apis.orchestratorUrl);
  effects.api.orchestrator.setBasePath(orchestratorBaseUrl);

  const networkServiceBaseUrl = ensureTrailingSlash(apis.networkServiceUrl);
  effects.api.networkService.setBasePath(networkServiceBaseUrl);
  effects.api.identity.setBasePath(ensureTrailingSlash(apis.identityUrl));
  effects.api.gridPlannerApi.setBasePath(
    apis.gridPlannerUrls.map(ensureTrailingSlash)
  );
};
